import { Root } from '@amcharts/amcharts5';
import { AxisRenderer, ValueAxis, XYChart } from '@amcharts/amcharts5/xy';

import { createBullets } from 'features/Status/components/StatusHistory/StatusHistoryChart/utils/createBullets';
import { StatusData } from 'features/Status/types/statusData';
import { lineSeries } from 'utils/charts/charts';
import { lineSeriesSettingsStatuses } from 'utils/charts/settings';

export const setSeries = (
  root: Root,
  chart: XYChart,
  yAxis: ValueAxis<AxisRenderer>,
  xAxis: ValueAxis<AxisRenderer>,
  chartData: StatusData[],
  lineColor: string
) => {
  const series = chart.series.push(
    lineSeries(root, lineSeriesSettingsStatuses(xAxis, yAxis, lineColor))
  );
  createBullets(series);
  series.data.setAll(chartData);
  series.appear();
};
